import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import axios from 'axios';

// import Backend from 'i18next-xhr-backend';
import detector from 'i18next-browser-languagedetector';
// not like to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

const ENDPOINT = process.env.REACT_APP_API_URL;

export const fetchFreshTranslations = (language) => {
  axios.get(`${ENDPOINT}/backend/settings/translations/${language}`)
    .then((response) => {
      const translationKeys = language === 'fr' ? response.data.translations['fr-FR'] : response.data.translations[language];
      i18n.addResourceBundle(language, 'translation', translationKeys);
      // Force reload
      i18n.changeLanguage(language)
    });
}

export const loadUserTranslations = (language) => {
  i18n.changeLanguage(language);
}

const resources = {
  en: {
    translation: require('./i18n/en/resource.json')
  },
  fr: {
    translation: require('./i18n/fr/resource.json')
  }
};

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  // .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  .use(detector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // lng: 'en',
    fallbackLng: 'en',
    // debug: true,
    resources,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    // keySeparator: true,
  });


export default i18n;